var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGmailOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.971 3.67462H2.029C0.91025 3.67462 0 4.58487 0 5.70362V26.2963C0 27.4151 0.91025 28.3253 2.029 28.3253H29.971C31.0898 28.3253 32 27.4151 32 26.2963V5.70362C32 4.58487 31.0898 3.67462 29.971 3.67462ZM27.3667 4.82293L16 13.1077L4.63331 4.82293H27.3667ZM3.59806 27.177H2.029C1.54344 27.177 1.14831 26.7819 1.14831 26.2963V8.44993L3.59806 10.2355V27.177ZM27.2536 27.177H4.74644V11.0726L15.6619 19.0286C15.7626 19.102 15.8813 19.1387 16 19.1387C16.1187 19.1387 16.2375 19.102 16.3381 19.0286L27.2536 11.0725V27.177ZM30.8517 26.2963C30.8517 26.7819 30.4566 27.177 29.971 27.177H28.4019V10.2355L30.8517 8.44993V26.2963ZM30.8517 7.029L16 17.8541L1.14831 7.029V5.70362C1.14831 5.21806 1.54344 4.82293 2.029 4.82293H2.68375L15.6619 14.2822C15.7626 14.3556 15.8813 14.3924 16 14.3924C16.1187 14.3924 16.2374 14.3556 16.3381 14.2822L29.3162 4.82293H29.9709C30.4565 4.82293 30.8516 5.21806 30.8516 5.70362V7.029H30.8517Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGmailOutlinedWhite);
export default __webpack_public_path__ + "static/media/icon_gmail_outlined_white.641cec16b025e9610710f8db48d264c8.svg";
export { ForwardRef as ReactComponent };